import { render, staticRenderFns } from "./TongueTurn.vue?vue&type=template&id=311bee2a&scoped=true&"
import script from "./TongueTurn.vue?vue&type=script&lang=js&"
export * from "./TongueTurn.vue?vue&type=script&lang=js&"
import style0 from "./TongueTurn.vue?vue&type=style&index=0&id=311bee2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311bee2a",
  null
  
)

export default component.exports